import { lazy } from "react";

const LitDashboard = lazy(() => import("../Pages/Dashboard"));
const LitSubscriber = lazy(() => import("../Pages/Subscriber"));
const LitControlHistory = lazy(() => import("../Pages/ControlHistory"));
const LitEvents = lazy(() => import("../Pages/Events"));

const litRoutes = [
  { path: "/lit/dashboard", name: "LIT Dashboard", component: LitDashboard },
  { path: "/lit/events", name: "LIT Events Captured", component: LitEvents },
  { path: "/lit/subscriber", name: "LIT Subscriber", component: LitSubscriber },
  // { path: "/lit/control-history", name: "LIT Control History", component: LitControlHistory },
];

export default litRoutes;
